import {
  ResponsiveContainer,
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';
import { type Metric, type MetricLog } from '@/database/types';

const customTooltipStyles = {
  background: 'rgba(249, 246, 240, 0.95)',
  border: '1px solid rgba(26, 34, 56, 0.16)',
  borderRadius: 14,
  color: 'var(--liturgy-ink)',
  boxShadow: '0 16px 32px rgba(26, 34, 56, 0.12)',
};

interface MetricChartProps {
  data: Array<MetricLog>;
  chartType: Metric['chartType'];
}

export function MetricChart({ data, chartType }: MetricChartProps) {
  const chartData = data
    .map((point) => ({
      ...point,
      date: new Date(point.timestamp).toISOString().split('T')[0],
      value: typeof point.value === 'number' ? point.value : 0,
    }))
    .slice(-7);

  if (chartType === 'bar') {
    return (
      <div
        style={{
          width: '100%',
          height: 220,
          animation: 'chartEnter 700ms ease-out both',
        }}
      >
        <ResponsiveContainer>
          <BarChart data={chartData}>
            <CartesianGrid stroke="rgba(26,34,56,0.08)" vertical={false} />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 12, fill: 'var(--liturgy-ink)' }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 12, fill: 'var(--liturgy-ink)' }}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip contentStyle={customTooltipStyles} />
            <Bar
              dataKey="value"
              radius={[8, 8, 0, 0]}
              fill="var(--sage-mist)"
              stroke="rgba(26,34,56,0.12)"
              strokeWidth={1}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        height: 220,
        animation: 'chartEnter 800ms ease-out both',
      }}
    >
      <ResponsiveContainer>
        <LineChart data={chartData}>
          <CartesianGrid stroke="rgba(26,34,56,0.08)" vertical={false} />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 12, fill: 'var(--liturgy-ink)' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 12, fill: 'var(--liturgy-ink)' }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip contentStyle={customTooltipStyles} />
          <Line
            type="monotone"
            dataKey="value"
            stroke="var(--aurora-rose)"
            strokeWidth={2.4}
            dot={false}
            activeDot={{ r: 4, stroke: 'var(--amber-glow)', strokeWidth: 1.5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
